import { define } from 'wicked-elements'

/**
 * Checks if cookie exists, removes if not
 */

define('[data-component~="cookie-banner"]', {
  init () {
    this.button = this.element.querySelector('button')
    if (-1 !== document.cookie.indexOf("cookie-note=1")) {
      this.element.style.display = "none"
    } else {
      this.element.style.display = "flex"
    }
    this.close = this.close.bind(this)
  },
  connected () {
    this.button.addEventListener('click', this.close)
  },
  disconnected () {
    this.button.removeEventListener('click', this.close)
  },
  close () {
    document.cookie = "cookie-note=1;path=/;max-age=864000"
    this.element.style.display = "none"
  }
})